// extracted by mini-css-extract-plugin
export default {"bottomSign":"bottomSign___BHbf3","bottomButton":"bottomButton___rNVwL","register-form":"register-form___hKikp"};